const DEV_MODE_KEY = 'immokompass:developer-mode';

/**
 * Event, das bei jedem Schreiben des Developer-Mode-Flags im SELBEN Tab
 * gefeuert wird (das native `storage`-Event feuert nur in ANDEREN Tabs).
 * Der Hook `useDeveloperMode` lauscht auf beides → der Toggle schlägt sofort
 * überall durch (Nav, Pakete, …), ohne Reload.
 */
export const DEVELOPER_MODE_CHANGED_EVENT = 'immokompass:developer-mode-changed';

/**
 * Developer Mode = „volle Superuser-/Admin-Sicht". Standard AN: Ein Superuser
 * behält seine gewohnte Sicht (Analytics, Doku, Superuser-Funktionen), bis er
 * den Toggle in den Einstellungen bewusst auf AUS stellt, um das Produkt wie
 * ein normaler Kunde zu sehen. Nur explizit gespeichertes '0' deaktiviert.
 *
 * Hinweis: Das Flag gilt browserweit (localStorage) und wirkt nur in
 * Kombination mit echtem Superuser-Status (`echterSuperuser && developerModeOn`).
 */
export function readDeveloperModeEnabled(): boolean {
  try {
    return localStorage.getItem(DEV_MODE_KEY) !== '0';
  } catch {
    return true;
  }
}

export function writeDeveloperModeEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(DEV_MODE_KEY, enabled ? '1' : '0');
  } catch {
    /* ignore */
  }
  try {
    window.dispatchEvent(new CustomEvent(DEVELOPER_MODE_CHANGED_EVENT, { detail: enabled }));
  } catch {
    /* ignore */
  }
}
